import { toast } from "react-toastify";
import ErrorUtils from "../../utils/ApiUtils/ErrorUtils";
import { useMutation, useQueryClient } from "react-query";
import { exportServicePackTranslation } from "../../api/exportServicePackTranslation";
import ExportTranslationCacheName from "../../utils/ExportTranslationCacheName";

export function useExportServicePack() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: exportServicePackTranslation,
    onSuccess: (response) => {
      toast.success("Extraction started successfully");
      queryClient.invalidateQueries(ExportTranslationCacheName.getExportTranslation());
    },
    onError: (error) => {
      let errorMsg = ErrorUtils.getErrorMessage(error);
      toast.error(errorMsg);
      console.error("Error submitting form:", error);
    },
  });
}
